export const SearchRoute = 'search';
export const BoxDealsRoute = '';
export const CheckoutRoute = 'checkout';
export const CheckoutFastCheckoutSubRoute = 'fast-checkout';
export const CheckoutAddressInvoiceSubRoute = 'address/invoice';
export const CheckoutAddressInvoiceRoute = CheckoutRoute + '/' + CheckoutAddressInvoiceSubRoute;
export const CheckoutAddressDeliverySubRoute = 'address/delivery';
export const CheckoutAddressDeliveryRoute = CheckoutRoute + '/' + CheckoutAddressDeliverySubRoute;
export const CheckoutOrderValidationSubRoute = 'bevestigen';
export const CheckoutOrderValidationRoute = CheckoutRoute + '/' + CheckoutOrderValidationSubRoute;
export const CheckoutPaymentCheckSubRoute = 'payment-check';
export const CheckoutPaymentSuccessSubRoute = 'payment-success';
export const CheckoutAssignCartSubRoute = 'cart';
export const SalesArticleRoute = 'salesarticle';
export const AuthRoute = 'auth';
export const AuthForgotPasswordSubRoute = 'forgot-password';
export const AuthRegisterSubRoute = 'registreer';
export const AuthRegisterRoute = AuthRoute + '/' + AuthRegisterSubRoute;
export const AuthPostLoginSubRoute = 'post-login';
export const AuthPostLogoutSubRoute = 'post-logout';
export const AuthChangePasswordSubRoute = 'change-password';
export const AuthResetPasswordSubRoute = 'reset-password';
export const AuthLogoutSubRoute = 'logout';
export const AuthLogoutRoute = AuthRoute + '/' + AuthLogoutSubRoute;
export const MobileRoute = 'mobile';
export const MobileMenuSubRoute = 'menu';
export const MobileCartSubRoute = 'cart';
export const MobileAccountSubRoute = 'account';
export const MobileCategoriesSubRoute = 'menu/categories';
export const MobileSubCategoriesSubRoute = 'menu/categories/:id/:title';
export const MobileMenuRoute = MobileRoute + '/' + MobileMenuSubRoute;
export const MobileCategoriesRoute = MobileRoute + '/' + MobileCategoriesSubRoute;
export const MobileSubCategoriesRoute = MobileRoute + '/' + MobileSubCategoriesSubRoute;
export const MobileCartRoute = MobileRoute + '/' + MobileCartSubRoute;
export const MobileAccountRoute = MobileRoute + '/' + MobileAccountSubRoute;
export const AccountRoute = 'account';
export const CustomerServiceFaqSubRoute = 'faq';
export const CustomerServiceTermsSubRoute = 'terms';
export const CustomerServicePrivacySubRoute = 'privacy';
export const CustomerServiceRetourSubRoute = 'retour';
export const CustomerServiceUspsContentSubRoute = 'waarom-box-delivery';
export const CustomerServiceAboutUsSubRoute = 'over-box-delivery';
export const CustomerServiceCookieSubRoute = 'cookies';
export const CustomerServiceCookieRoute = AccountRoute + '/' + CustomerServiceCookieSubRoute;
export const CustomerServiceAboutUsRoute = AccountRoute + '/' + CustomerServiceAboutUsSubRoute;
export const CustomerServiceFaqRoute = AccountRoute + '/' + CustomerServiceFaqSubRoute;
export const CustomerServiceTermsRoute = AccountRoute + '/' + CustomerServiceTermsSubRoute;
export const CustomerServicePrivacyRoute = AccountRoute + '/' + CustomerServicePrivacySubRoute;
export const CustomerServiceRetourRoute = AccountRoute + '/' + CustomerServiceRetourSubRoute;
export const CustomerServiceUspsContentRoute = AccountRoute + '/' + CustomerServiceUspsContentSubRoute;
export const ForgotPasswordRoute = AuthRoute + '/' + AuthForgotPasswordSubRoute;
export const LoginRoute = AuthRoute;
export const ChangePasswordRoute = AuthRoute + '/' + AuthChangePasswordSubRoute;
export const CategoryRoute = 'category';
export const CheckoutFastCheckoutRoute = CheckoutRoute + '/' + CheckoutFastCheckoutSubRoute;
export const CheckoutAddressRoute = CheckoutRoute + '/' + CheckoutAddressInvoiceSubRoute;
export const CheckoutPaymentSuccessRoute = CheckoutRoute + '/' + CheckoutPaymentSuccessSubRoute;
export const CheckoutAssignCartRoute = CheckoutRoute + '/' + CheckoutAssignCartSubRoute;
export const BoxDealsByCategorySubRoute = 'category/:id/:title';
export const BoxDealsByBrandSubRoute = 'brand/:brand';
export const BoxDealsByTemporaryDiscount = 'promoties';
export const SalesArticleDetailsSubRoute = ':id/:title';
export const SalesArticleDetailsPicturesSubRoute = ':id/:title/pictures';
export const BlogRoute = 'blog';
export const BlogArticleSubRoute = ':id/:title';

export const OrdersSubRoute = 'orders';
export const OrdersRoute = AccountRoute + '/' + OrdersSubRoute;
export const SettingsSubRoute = 'settings';
export const SettingsRoute = AccountRoute + '/' + SettingsSubRoute;

export function ByCategoryRoute(urlId: string | number, urlName: string) {
  return CategoryRoute + '/' + urlId + '/' + urlName;
}

export function SalesArticleDetailRoute(urlId: string | number, urlName: string) {
  return SalesArticleRoute + '/' + urlId + '/' + urlName;
}

export function ZoomPictureRoute(urlId: string | number, urlName: string) {
  return SalesArticleDetailRoute(urlId, urlName) + '/pictures';
}

export function ByMobileSubCategoriesRoute(urlId: string | number, urlName: string) {
  return MobileSubCategoriesRoute.replace(':id', urlId.toString()).replace(':title', urlName);
}

export function ByBlogArticleRoute(urlId: string | number, urlName: string) {
  return BlogArticleSubRoute.replace(':id', urlId.toString()).replace(':title', urlName);
}

export function ByAccountMenu(page: string) {
  return AccountRoute + '/' + page;
}

export function ByBrandRoute(brandId: string): string {
  return BoxDealsRoute + '/' + BoxDealsByBrandSubRoute.replace(':brand', brandId);
}
